import './style.scss';
import logo_react from '../../assets/images/logo_react.svg';
import logo_youtube from '../../assets/images/social/youtube.png';
import logo_linkedin from '../../assets/images/social/linkedin.png';
import logo_instagram from '../../assets/images/social/instagram.png';
import logo_github from '../../assets/images/social/github.png';

function FooterComponent() {
    return (
        <div style={{ height: "200px" }}>
            <div className="fotter">
                <div className="fotter_copy">
                    <div className="fotter_copy_esencoder">
                        <div className="fotter_copy_esencoder_encoder text-center"><span className="fotter_copy_esencoder_es">ES </span>ENCODER &copy; 2021 </div>
                    </div>
                </div>
                <div className="fotter_react">
                    <div>

                        <img src={logo_react} className='fotter_react_logo' alt="react" />

                    </div>
                    <div>
                        <a href="https://www.youtube.com/user/edgarsalinas17" target="_blank"  rel="noreferrer">
                            <img src={logo_youtube} className="fotter_react-social" alt="youtube" />
                        </a>
                    </div>
                    <div>
                        <a href="https://www.instagram.com/enermexico/?hl=es-la" target="_blank"  rel="noreferrer">
                            <img src={logo_instagram} className="fotter_react-social" alt="instagram" />
                        </a>
                    </div>
                    <div>
                        <a href="https://www.linkedin.com/in/edgar-salinas-esencoder" target="_blank"  rel="noreferrer">
                            <img src={logo_linkedin} className="fotter_react-social" alt="linkedin" />
                        </a>
                    </div>
                    <div>
                        <a href="https://github.com/edgarsw" target="_blank"  rel="noreferrer">
                            <img src={logo_github} className="fotter_react-social" alt="github" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterComponent;